<mat-searchable-select mat-searchable-select-highlight>
  <mat-searchable-select-label>Lorem Words</mat-searchable-select-label>
  <mat-searchable-select-search-label>Search</mat-searchable-select-search-label>
  <mat-searchable-select-list [options]="options">
    <ng-template matSearchableSelectOption
                 let-option="option">
      {{option}}
    </ng-template>
  </mat-searchable-select-list>
</mat-searchable-select>
